




























































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { DxAutocomplete } from 'devextreme-vue';
import Card from '@/components/default/Card.vue';
import notificationService from '@/services/notificationService';
import projectsRepository from '@/services/projectsRepository';
import dxCustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { DxForm, DxSimpleItem, DxRequiredRule, DxGroupItem, DxLabel } from 'devextreme-vue/form';

import {
  ContactsClient,
  QuotationStatus,
  QuotationDetailedDto,
  ProjectsClient,
  QuotationType,
  AssignedContact,
  ProjectContactsClient,
  ITunnelGroup,
  TunnelGroupsClient,
} from '@/data/web-api-client';

@Component({
  components: {
    Card,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxLabel,
    DxAutocomplete,
  },
})
export default class QuotationDetailsCard extends Vue {
  @Prop({ required: true })
  quotation!: QuotationDetailedDto;

  @Prop({ required: true })
  saving: boolean = false;

  @Prop({ required: false, default: false })
  disabled: boolean = false;

  private tunnelGroups: ITunnelGroup[] = [];
  private calcValue: number = 0;
  private calculatedValue: number = 0;

  editMode: boolean = false;

  private projectContactsClient: ProjectContactsClient = new ProjectContactsClient(undefined, this.$axios);

  toggleEditMode() {
    this.editMode = !this.editMode;
  }

  private async mounted() {
    await this.loadTunnelGroups();
  }

  save() {
    const form: any = this.$refs.quotationForm;
    const validationResult = form.instance.validate();
    if (validationResult.isValid) {
      this.$emit('updated');
      this.editMode = false;
    } else {
      notificationService.invalidForm();
    }
  }

  private async loadTunnelGroups() {
    this.tunnelGroups = await new TunnelGroupsClient(undefined, this.$axios).get();
  }

  get projectsOptions() {
    const self = this;
    return {
      dataSource: new DataSource({
        store: new dxCustomStore({
          key: 'id',
          load: async (loadOptions) => {
            if (Array.isArray(loadOptions.filter) && loadOptions.filter.length > 1 && loadOptions.filter[0] === 'id') {
              return {
                data: [],
                totalCount: 0,
              };
            }
            if (loadOptions.searchExpr && loadOptions.searchValue && loadOptions.searchOperation) {
              loadOptions.filter = [loadOptions.searchExpr, loadOptions.searchOperation, loadOptions.searchValue];
            }
            const result = await projectsRepository.lookup(loadOptions);
            return {
              data: result.data.data,
              totalCount: result.data.totalCount,
            };
          },
          byKey: async (val: any) => {
            const client = new ProjectsClient(undefined, this.$axios);
            return await client.getProjectBasicInfo(val);
          },
        }),
        paginate: true,
      }),
      valueExpr: 'id',
      displayExpr: 'name',
      searchExpr: 'name',
      searchEnabled: true,
      disabled: !self.editMode,
      showClearButton: true,
    };
  }

  get quotationStatusses() {
    return [
      { value: QuotationStatus.Draft, text: 'Klad' },
      { value: QuotationStatus.Open, text: 'Open' },
      { value: QuotationStatus.Send, text: 'Verstuurd' },
      { value: QuotationStatus.Approved, text: 'Aanvaard' },
      { value: QuotationStatus.Declined, text: 'Afgewezen' },
      { value: QuotationStatus.Replaced, text: 'Vervangen' },
    ];
  }

  get projectTypesOptions() {
    const catalog = this.$store.getters['catalogs/list']('ProjectTypes');
    const values = catalog ? catalog.values : [];

    return {
      items: values,
      disabled: this.disabledWhenSend,
    };
  }

  get workTypesOptions() {
    const catalog = this.$store.getters['catalogs/list']('WorkTypes');
    const values = catalog ? catalog.values : [];

    return {
      items: values,
      disabled: this.disabledWhenSend,
    };
  }

  get quotationTypes() {
    return {
      dataSource: [
        { value: QuotationType.Standard, text: 'Standaard' },
        { value: QuotationType.AdditionalWork, text: 'Meerwerk' },
        { value: QuotationType.FlatRate, text: 'Forfaitair' },
        { value: QuotationType.Raming, text: 'Raming' },
        { value: QuotationType.Execution, text: 'Uitvoeringsstaat' }
      ],
      displayExpr: 'text',
      valueExpr: 'value',
      disabled: this.disabledWhenSend,
    };
  }

  get internalContactsOptions() {
    const users: any[] = this.$store.getters['employees/items'];
    const values = users ? users.map((x: any) => x.displayName) : [];

    return {
      dataSource: values,
      disabled: this.disabledWhenSend,
    };
  }

  get disabledWhenSend() {
    return this.quotation.status! > QuotationStatus.Open || !this.editMode;
  }

  get contactsOptions() {
    const self = this;
    const client = new ContactsClient(undefined, this.$axios);
    return {
      dataSource: new DataSource({
        store: new dxCustomStore({
          key: 'id',
          load: async (loadOptions: any) => {
            const clients = await this.projectContactsClient.getContacts(self.quotation.projectId!).then((assignedContacts: AssignedContact[]) => {
              return assignedContacts.filter((contact: AssignedContact) => contact.sendQuotation);
            });

            return clients.map((client: AssignedContact) => client.contact);
          },
          byKey: async (val: any) => {
            const clients = await this.projectContactsClient.getContacts(self.quotation.projectId!).then((assignedContacts: AssignedContact[]) => {
              return assignedContacts.filter((contact: AssignedContact) => contact.contact != undefined && contact.contact.id == val && contact.sendQuotation);
            });

            return clients.map((client: AssignedContact) => client.contact);
          },
        }),
        paginate: this.quotation.projectId ? false : true,
      }),
      displayExpr: 'displayName',
      searchEnabled: true,
      disabled: self.disabledWhenSend,
      showClearButton: true,
    };
  }

  public formFieldDataChanged(e: any) {
    if (e.dataField == 'internalContact') {
      const users: any[] = this.$store.getters['employees/items'];
      var employee = users.find((x) => x.displayName == e.value);
      this.quotation.internalContactMail = employee.mail;
    }

    if (e.dataField === 'tunnelGroupsId') {
      this.quotation.tunnelGroupsId = e.value;
    }

    if (e.dataField == 'customer') {
      this.quotation.customer = e.value;
    }
  }

  get getTotalDuration() {
    var total = 0;
    this.quotation.measuringDurations!.forEach((x) => {
      total += x.durationInHours!;
    });
    return total;
  }

  get tunnelGroupsOptions() {
    const items = this.tunnelGroups.map((dg) => ({
      value: dg.id,
      text: dg.name,
    }));

    return {
      dataSource: items,
      disabled: this.disabledWhenSend,
      showClearButton: true,
      displayExpr: 'text',
      valueExpr: 'value',
      filterExpr: 'value',
    };
  }

  public calc() {
    this.calculatedValue = Math.round(this.calcValue * this.getTotalDuration);
  }
}
